import React from "react";

import dollericon from "../../../../assets/images/dollericon.png";
import HorizontalLine from "../../../shared/HorizontalLine";
import MainButton from "../../../shared/Button";
import GoogleMap from "../../../shared/map";
import {
  PriceQuotationMain,
  PackageDeliveryBox,
  Maincontant,
  PriceMain,
  ButtonMainSec,
} from "../styles/PriceQuotationStyle";

const PriceQuotation = () => {
  return (
    <PriceQuotationMain>
      <GoogleMap LocationIcon={false} hasRoutes={true} />
      <PackageDeliveryBox>
        <Maincontant>
          <h6>Package Delivery</h6>
          <h6 className="countItem">2 Boxes of clothes</h6>
          <HorizontalLine />
          <div className="address">
            <span>Pickup: </span>
            <p>John doe, 1213 Washington Blvd, Belpre</p>
          </div>
          <div className="address">
            <span>Delivery: </span>
            <p>Alex, 121 Pike St, Marietta</p>
          </div>
          <HorizontalLine />
          <PriceMain>
            <div className="pricemain">
              <img src={dollericon} alt="dollericon" />
              <span>$20</span>
            </div>
            <div className="timemain">
              <span>ETA:</span>
              <p>20 Minutes</p>
            </div>
          </PriceMain>
          <ButtonMainSec>
            <MainButton type="button" label="Approve" />
            <MainButton type="button" label="Request Again" border={true} />
          </ButtonMainSec>
        </Maincontant>
      </PackageDeliveryBox>
    </PriceQuotationMain>
  );
};

export default PriceQuotation;
